/**
 * Created by jonas on 2023-01-11.
 */
import {BS2Symbol, BS2SymbolStates} from "./BS2Symbol";
import {BS2Reel} from "./BS2Reel";
import {gsap} from "gsap";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {BS2} from "../BS2";
import {BS2Sound} from "../config/sound/BS2Sound";
import {SimpleReelModelSymbolData, SimpleReelModelSymbolPosition} from "../../core/reel/simplereel/SimpleReelModel";

export class ScatterSymbol extends BS2Symbol{

    constructor(_symbolName:string, initState:BS2SymbolStates, reelsView:BS2Reel,symbolsPosition?:SimpleReelModelSymbolPosition) {
      super(_symbolName, initState,reelsView,symbolsPosition);
    }

    public getSqueezeAnimation():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline({
            onComplete:()=>{
                this.destroy();
            }
        });
        const spine:PIXI.spine.Spine |undefined= this.getSymbolSpine(this._symbolName);
        if (spine) {
            tl.add(() => {
                this.addSpineToView(spine);
                this.moveToMaskedHighLight();
            })
            tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 0, "squish",false));
            tl.add(() => {
                BS2.soundPlayer.playSound(BS2Sound.SCATTER_COLLAPSE.next());
            }, "<");
            tl.add(gsap.to(this._mainSprite, {duration:0.001, alpha:0}), "<");
        }
        return tl;
    }

    public getFsReTrigger() {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this._symbolName);
        if (spine) {
            tl.add(() => {
                this.addSpineToView(spine);
                this.moveToMaskedHighLight();
            })
            tl.add(()=>{BS2.soundPlayer.playSound(BS2Sound.S_PLUS_ONE)});
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, "+1"));
            tl.add(gsap.to(this._mainSprite, {duration:0.001, alpha:0}), "<");
        }
        return tl;
    }
}